import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';
import { useAuthStore } from '@/stores/auth';

type SingleRes = { id: string; success: boolean };
type BulkRes = {
  total: number;
  reset: number;
  transitioned_to_healthy: number;
  errors: { id: string; error: string }[];
};

const QK = ['team-members'];
const ADMIN_QK = ['team-members-admin'];

function invalidateAll(qc: ReturnType<typeof useQueryClient>): void {
  qc.invalidateQueries({ queryKey: QK });
  qc.invalidateQueries({ queryKey: ADMIN_QK });
  qc.invalidateQueries({ queryKey: ['approacher'] });
  qc.invalidateQueries({ queryKey: ['daily-earnings'] });
  qc.invalidateQueries({ queryKey: ['collector-summary'] });
  // If admin reset themselves (admin is also a collector), refresh their
  // auth so streak_resumed_at hits the auth store immediately.
  void useAuthStore.getState().refreshAuth();
}

export function useResetStreak() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send<SingleRes>(`/api/team-members/reset-streak/${id}`, {
        method: 'POST',
      }),
    onSuccess: () => {
      invalidateAll(qc);
      toast('Streak reseteado', 'success');
    },
    onError: () => toast('Error al resetear streak', 'error'),
  });
}

export function useResetAllStreaks() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: () =>
      pb.send<BulkRes>('/api/team-members/reset-all-streaks', {
        method: 'POST',
      }),
    onSuccess: (r) => {
      invalidateAll(qc);
      const msg =
        `${r.reset}/${r.total} streaks reseteados` +
        (r.transitioned_to_healthy > 0
          ? `, ${r.transitioned_to_healthy} desbaneados`
          : '');
      toast(msg, 'success');
    },
    onError: () => toast('Error en bulk reset', 'error'),
  });
}
